import axios from "axios";
import config from "../config/config";
import { getHeaders } from "./apiHelper";

const API_URL = config.API_URL;

const prepareUserPayload = (data) => {
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
        return { payload: data, isFormData: true };
    }
    let hasFile = false;
    if (data && typeof data === 'object') {
        for (const key of Object.keys(data)) {
            if (typeof File !== 'undefined' && data[key] instanceof File) {
                hasFile = true;
                break;
            }
        }
    }
    if (hasFile) {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            if (data[key] !== null && data[key] !== undefined) {
                formData.append(key, data[key]);
            }
        });
        return { payload: formData, isFormData: true };
    }
    return { payload: data, isFormData: false };
};

export const storePlayer = async (data) => {
    const { payload, isFormData } = prepareUserPayload(data);
    const response = await axios.post(`${API_URL}user`, payload, { headers: getHeaders(isFormData) });
    return response.data;
};

export const getPlayer = async () => {
    const response = await axios.get(`${API_URL}user/player`, {
        headers: getHeaders()
    });
    return response.data;
};

export const getPlayerAdmin = async () => {
    const response = await axios.get(`${API_URL}admin/user/player`, {
        headers: getHeaders()
    });
    return response.data;
};

export const getDetailPlayer = async (id) => {
    const response = await axios.get(`${API_URL}user/${id}`, {
        headers: getHeaders()
    });
    return response.data;
};

export const updatePlayer = async (id, data) => {
    const { payload, isFormData } = prepareUserPayload(data);
    const response = await axios.post(`${API_URL}user/${id}`, payload, { headers: getHeaders(isFormData) });
    return response.data;
};

export const deletePlayer = async (id) => {
    const response = await axios.delete(`${API_URL}user/${id}`, {
        headers: getHeaders()
    });
    return response.data;
};

export const getCompany = async () => {
    const response = await axios.get(`${API_URL}company-list`, {
        headers: getHeaders()
    });
    return response.data;
};

export const getCompanyAdmin = async () => {
    const response = await axios.get(`${API_URL}admin/company-list`, {
        headers: getHeaders()
    });
    return response.data;
};

export const getSquad = async () => {
    const response = await axios.get(`${API_URL}division`,{
        headers: getHeaders()
    });
    return response.data;
};

export const addToMaker = async (id) => {
    const response = await axios.post(`${API_URL}add-to-maker/${id}`, null, {
        headers: getHeaders()
    });
    return response.data;
};

export const removeFromMaker = async (id) => {
    const response = await axios.post(`${API_URL}remove-from-maker/${id}`, null, {
        headers: getHeaders()
    });
    return response.data;
};

export const removeFromPlayer = async (id) => {
    const response = await axios.post(`${API_URL}remove-from-player/${id}`, null, {
        headers: getHeaders()
    });
    return response.data;
};